import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import Moment from "react-moment";
import { useParams } from "react-router-dom";
import { studyLevelFormManagementServices } from "../../../../../APIServices/studyLevelFormManagementServices";
import SplitPane from "react-split-pane";
import { PageLoader } from "../../../../../Components/NoDataFoundTable/NoDataFoundTable";

const FormMetadataProperties = ({ onMouseDown, tableRef, metadata }) => {
  const [showLoader, setShowLoader] = useState(false);
  const [version, setVersion] = useState(1);
  let { studyId } = useParams();

  const getHeighestVersionStudyLevelFormHistory = async () => {
    setShowLoader(true);
    let data =
      await studyLevelFormManagementServices.getHeighestVersionStudyLevelFormHistory(
        studyId,
        metadata?.formId
      );
    setShowLoader(false);
    setVersion(data?.data || 1);
  };
  useEffect(() => {
    getHeighestVersionStudyLevelFormHistory();
  }, [metadata]);

  return (
    <>
      <SplitPane
        split="vertical"
        minSize={"100%"}
        style={{ height: "-webkit-fill-available" }}
      >
        {showLoader ? (
          <PageLoader/>
        ) : (
          <>
            <Table ref={tableRef} className="m-0 custom-table" hover striped>
              <thead className="position-sticky top-0 z-1">
                <tr>
                  <th
                    onMouseDown={(e) => onMouseDown(e, 0)}
                    className="text-center"
                    style={{ width: 45 }}
                  >
                    Sr.
                  </th>
                  <th onMouseDown={(e) => onMouseDown(e, 1)}>Attribute</th>
                  <th onMouseDown={(e) => onMouseDown(e, 2)}>Value</th>
                </tr>
              </thead>
              <tbody>
                {Number(metadata?.version || 0) > 0 && (
                  <tr>
                    <td className="text-center">1.</td>
                    <td>Form Version</td>
                    <td className="text-capitalize">{metadata?.version}</td>
                  </tr>
                )}
                <tr>
                  <td className="text-center">
                    {Number(metadata?.version || 0) > 0 ? 2 : 1}.
                  </td>
                  <td>Column Heightest Version</td>
                  <td className="text-capitalize">{version}</td>
                </tr>
                <tr>
                  <td className="text-center">
                    {Number(metadata?.version || 0) > 0 ? 3 : 2}.
                  </td>
                  <td>Updated By</td>
                  <td className="text-capitalize">{metadata?.updatedBy}</td>
                </tr>
                <tr>
                  <td className="text-center">
                    {Number(metadata?.version || 0) > 0 ? 4 : 3}.
                  </td>
                  <td>Updated Date | Time</td>
                  <td className="text-capitalize">
                    <Moment format="DD MMM YYYY | HH:mm" withTitle>
                      {metadata?.updatedAt}
                    </Moment>
                  </td>
                </tr>
              </tbody>
            </Table>
          </>
        )}
      </SplitPane>
    </>
  );
};

export default FormMetadataProperties;
